// @flow
import { fork } from 'redux-saga/effects';
import setPostflopSituation from './setPostflopSituation';
import setPostflopSimilar from './setSimilar';
import getCombo from './getCombo';
import getResultsStat from './getResultsStat';

export default function* postflopSaga() {
  yield fork(setPostflopSituation);
  yield fork(setPostflopSimilar);
  yield fork(getCombo);
  yield fork(getResultsStat);
}
